<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties
const listingName = computed(() => viewStore.listingName)
const tableName = computed(() => viewStore.tableName)
const allSelected = computed(() => viewStore.allSelected)
const ids = computed(() => viewStore.ids || [])
const itemCount = computed(() => viewStore.itemCount || 0)
const allItemsSelected = computed(() => viewStore.allItemsSelected)

const showSelectAllMessage = computed(() => {
    return !!(
        tableName.value?.indexOf('product_variations__') === 0 &&
        allSelected.value &&
        ids.value.length < itemCount.value
    )
})

// Methods
const selectAllItems = () => {
    viewStore.selectAllItems()
}

const clearAllItemsSelection = () => {
    viewStore.selectNone()
}
</script>

<template>
    <div v-if="showSelectAllMessage" class="ms-3 mb-2 py-1">
        <strong>
            <template v-if="allItemsSelected">
                All {{ itemCount }} items are selected.
                <button class="ms-1 btn btn-light btn-sm" type="button" @click="clearAllItemsSelection">
                    Clear selection
                </button>
            </template>

            <template v-else>
                {{ ids.length }} of {{ itemCount }} items are selected.
                <button class="ms-1 btn btn-light btn-sm" type="button" @click="selectAllItems">
                    Select all {{ itemCount }} items
                </button>
            </template>
        </strong>
    </div>
</template>